// ACTIONS
export const SET_SIDEBAR_VISIBLE = '[] set sidebar visible';
export const setSidebarVisible = (payload) => ({ type: SET_SIDEBAR_VISIBLE, payload });

// REDUCER
const INITIAL_STATE = {
  sidebarVisible: false,
};

export default function SidebarReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
  case SET_SIDEBAR_VISIBLE:
    return {
      ...state,
      sidebarVisible: action.payload.visible,
    };

  default:
    return state;
  }
}
